module.exports = __webpack_public_path__ + "static/img/logo_jt_1.fbc091f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_jt_1.png
// module id = 1v/L
// module chunks = 0